export const dateToIso = (date: string | null): string | null => {
  if (!date || date === '') return null;
  return new Date(date).toISOString();
};
export const dateToCalendar = (date: string | null): string | null => {
  if (!date || date === '') return null;
  return date.split('T')[0];
};
/**
 * DATE_SHORT => 'ddds'
 */
enum DatePreset {
  /**
   * Return example : terça-feira, 9 de maio de 2023
   */
  DATE_HUGE = 'DATE_HUGE',
  /**
   * Return example : 14/10/1983
   */
  DATE_MED = 'DATE_MED',
  /**
   * Return example : 14/10/1983
   */
  DATE_SHORT = 'DATE_SHORT',
}
const DatePresets: Record<keyof typeof DatePreset, Intl.DateTimeFormatOptions> = {
  DATE_HUGE: {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  DATE_MED: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },
  DATE_SHORT: {
    year: '2-digit',
    month: 'short',
    day: 'numeric',
  },
};
/**
 *
 * @param date
 * @param preset
 * @param locale
 * @returns
 */
export const formatDate = (date: string | Date, preset?: keyof typeof DatePreset, locale = 'en'): string => {
  if (!date || date === '') return '-';
  if (!preset) return new Date(date).toLocaleDateString(locale);
  const currentLocaleOptions = DatePresets[preset] as Intl.DateTimeFormatOptions;
  const formatter = new Intl.DateTimeFormat(locale, currentLocaleOptions);

  return formatter.format(new Date(date));
};

// This function was created to format dates for events. Events date acf field was changed from date picker to text input, so we need to handle both old and new formats.
export const formatDateEvents = (
  date: string | Date,
  preset?: keyof typeof DatePreset,
  locale = 'en'
): string => {
  if (!date || date === '') return '-';

  // Regex for YYYYMMDD (Old event date format (was date picker, now is text input))
  const yyyymmddRegex = /^\d{8}$/;
  // Regex for YYYY-MM-DD HH:mm:ss (blog format)
  const isoLikeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

  const dateStr = typeof date === 'string' ? date : date.toISOString();
  if (yyyymmddRegex.test(dateStr) || isoLikeRegex.test(dateStr)) {
    const parsedDate =
      yyyymmddRegex.test(dateStr)
        ? new Date(
            `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`
          )
        : new Date(dateStr.replace(' ', 'T'));
    const currentLocaleOptions = preset ? DatePresets[preset] : undefined;
    return new Intl.DateTimeFormat(locale, currentLocaleOptions).format(parsedDate);
  }

  // If not matching regex for old event date format or blog format, render date as is.
  return typeof date === 'string' ? date : date.toISOString();
};

export const getCurrentDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  // if (dd < 10) dd = `0${dd}`;
  // if (mm < 10) mm = `0${mm}`;

  return yyyy + '-' + mm + '-' + dd;
}